export { SearchSatisfaction as default } from './search-satisfaction';
export * from './search-satisfaction';
